import { render, staticRenderFns } from "./RipaAppBar.vue?vue&type=template&id=920a32d0"
import script from "./RipaAppBar.vue?vue&type=script&lang=js"
export * from "./RipaAppBar.vue?vue&type=script&lang=js"
import style0 from "./RipaAppBar.vue?vue&type=style&index=0&id=920a32d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports